import React, { useCallback, useEffect, useState } from 'react';
import { Container, IconButton, Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { DataGrid } from '@material-ui/data-grid';

import TableHeader from '../common/TableHeader';
import AddAdmUser from '../Forms/AddAdmUser';
import { ModalAction } from '../common/Modal';
import { Title } from './style';

import { deleteAdmUserById, ativarAdmUserById, generateAdmUser, getUsers } from '../../actions/Auth';
import { Text } from '../common/NotificationTable/style';
import { Noresults } from '../../Layout/style';

const AdminPermissions = () => {
  const dispatch = useDispatch();
  const { users } = useSelector(({ auth }) => ({
    users: auth?.users || [],
  }));

  const [modal, setModal] = useState({
    open: false,
    type: null,
    title: null,
    action: null,
  });
  const [formData, setFormData] = useState({});
  const [searchString, setSearchString] = useState('');
  const [filteredElements, setFilteredElements] = useState('');
  let valideFormData = formData?.email;

  const { id } = useSelector(({ auth }) => ({
    id: auth?.userData?.userLogado?.adm_login || null
  }));

  useEffect(() => {
    setFormData({ ...formData, userWhoCreated: id })
  }, [id]);



  useEffect(() => {
    if (searchString?.length > 0) {
      setFilteredElements(
        users.filter((i) => {
          return i.email.toUpperCase().match(searchString.toUpperCase());
        }),
      );
    } else setFilteredElements(users);
  }, [users, searchString]);

  const handleAdd = useCallback(async () => {
    await setFormData({ ...formData, userWhoCreated: id })
    dispatch(generateAdmUser(formData)).then(() => closeAndUpdate());
  });

  const closeAndUpdate = useCallback(() => {
    dispatch(getUsers());
    setModal({ open: false, type: null, title: null, action: null });
    setFormData({});
  });

  const columns = [
    {
      field: 'email',
      flex: 2,
      headerName: 'E-mail',
      sortable: true,
      renderCell: ({ row }) => <Text>{row.email}</Text>,
    },
    {
      field: 'active',
      flex: 1,
      headerName: 'Ativo?',
      renderCell: ({ row }) => <Text>{row.active === 1 ? 'Sim' : 'Não'}</Text>,
    },
    {
      field: 'actions',
      headerName: 'Açoes',
      flex: 1.2,
      sortable: false,
      renderCell: ({ row }) => (
        <>
          {row.active === 1 ?
            <IconButton
              onClick={() =>
                setModal({
                  open: true,
                  type: 'del',
                  title: 'Remover Permissão',
                  action: () => {
                    dispatch(deleteAdmUserById(row.id)).then(() => closeAndUpdate());
                  },
                })
              }
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </IconButton>
            :
            <IconButton title={'Ativar Usuário'} onClick={() => dispatch(ativarAdmUserById(row.id)).then(() => closeAndUpdate())}>
              <FontAwesomeIcon icon={faCheck} />
            </IconButton>
          }
        </>
      ),
    },
  ];

  return (
    <>
      <Container>
        <Title variant="h2">Gestão de Permissões</Title>
        <TableHeader
          setSearchString={setSearchString}
          placeholder="Pesquisar por E-mail"
          btnAction={() =>
            setModal({
              open: true,
              type: 'add',
              title: 'Adicionar Usuário',
              action: () => handleAdd(),
            })
          }
        />
        <div style={{ height: 500, width: '100%', background: 'white' }}>
          <DataGrid
            components={{
              NoRowsOverlay: () => (
                <Noresults>
                  <span>
                    Resultados não encontrado
                  </span>
                </Noresults>
              ),
            }}
            pageSize={10}
            disableSelectionOnClick
            disableColumnMenu
            hideFooterSelectedRowCount
            rows={filteredElements.length ? filteredElements : []}
            columns={columns}
          />
        </div>
      </Container>
      <ModalAction
        title={modal.title || ' '}
        successAction={modal.type === 'add' ? () => handleAdd() : modal.action}
        open={modal.open}
        successActive={modal.type === 'add' ? (valideFormData ? true : false) : true}
        successLabel={modal.type === 'del' && 'Remover'}
        backAction={() => {
          setModal({ open: false, type: null });
          setFormData({});
        }}
      >
        {modal.type === 'add' && <AddAdmUser formData={formData} userWhoCreated={id} setFormData={setFormData} />}
        {modal.type === 'del' && <Typography>Tem certeza que deseja remover a permissão do Usuário?</Typography>}
      </ModalAction>
    </>
  );
};

export default AdminPermissions;
